<template>
  <div :class="tileStyles">
    <i @click="handleClose" class="tile__close fa fa-close"></i>

    <div v-if="$slots['title']">
      <slot name="title"></slot>
    </div>
    <h3 v-else-if="title" class="tile__heading tile__heading--title">
      <a
        v-if="link"
        class="tile__link tile__link--title"
        :href="link.href"
        :title="linkTitle"
        :tabindex="clickable ? -1 : 0"
        @click="handleLinkClick">
        {{ title }}
      </a>
      <span v-else>{{ title }}</span>
    </h3>

    <div v-if="$slots['meta']">
      <slot name="meta"></slot>
    </div>
    <p v-else-if="meta" class="tile__text tile__text--meta">{{ meta }}</p>

    <div v-if="$slots['content']">
      <slot name="content"></slot>
    </div>
    <p v-else-if="content" class="tile__text tile__text--content">{{ content }}</p>

    <div v-if="$slots['call-to-action']">
      <slot name="call-to-action"></slot>
    </div>
    <div v-else-if="link" class="tile__call-to-action">
      <p class="tile__text tile__text--link-wrapper">
        <a
          class="tile__link tile__link--call-to-action"
          :href="link.href"
          :title="linkTitle"
          @click="handleLinkClick">
          {{ link.text }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      onHideSummaryTile: {
        type: Function,
      },
      title: {
        type: String,
      },
      meta: {
        type: String,
      },
      content: {
        type: String,
      },
      link: {
        type: Object,
      },
      onClick: {
        type: Function
      }
    },

    computed: {
      tileStyles() {
        const defaults = {
          'tile': true,
          'tile--summary': true
        };

        return Object.assign(defaults, this.styles);
      },

      linkTitle() {
        return this.link !== undefined ? this.link.title : this.title;
      },
    },

    methods: {
      handleLinkClick(event) {
        if (this.onClick !== undefined) {
          this.onClick(event);
        }
      },

      handleClose() {
        this.onHideSummaryTile();
      }
    }
  };
</script>
